import {
  AddExpenseTypeResponse,
  ExpenseTypeError,
  ExpenseTypePayload,
  ExpenseTypeResponse,
} from '@core/interface/expense-type';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ExpenseTypeActions = createActionGroup({
  source: 'ExpenseType',
  events: {
    'Load Expense Types': props<PagePayload>(),
    'Load Expense Types Success': props<ExpenseTypeResponse>(),
    'Load Expense Types Failure': props<ExpenseTypeError>(),
    'Add Edit Expense Type': props<ExpenseTypePayload>(),
    'Add Expense Type Success': props<AddExpenseTypeResponse>(),
    'Update Expense Type Success': props<AddExpenseTypeResponse>(),
    'Add Expense Type Failure': props<ExpenseTypeError>(),
    'Update Expense Type Failure': props<ExpenseTypeError>(),
    'Reset Expense Types': emptyProps(),
  },
});
